import axios from "axios";
import { photoboothName } from "../utils/fixers";

export const getAllImages = async ({
  setImages,
  setLoading,
  setError,
  setCount,
  page,
  scrollToTop,
}) => {
  try {
    setLoading(true);
    const { data, status } = await axios.get(
      `https://engagements.vehub.live/comonphotobooth/s3image/explorefile.php?eventname=${photoboothName}&page=${page}`
    );

    const { images, totalcount } = data;

    if (status === 200) {
      scrollToTop();
      setImages(images);
      if (totalcount) setCount(totalcount);
      setLoading(false);
    }
  } catch (err) {
    setError(err);
    setLoading(false);
  }
};

export const uploadImage = async ({ body, setError, setUrl, sendMessage }) => {
  try {
    const response = await axios.post(
      "https://enzored.risingbanyan.com/photobooth/api/uploadimage",
      body
    );

    if (response.data?.message === "Image uploaded successfully.") {
      setUrl(true);
    }
  } catch (err) {
    setError(err);
  }
};

export const login = async ({
  body,
  navigate,
  setError,
  setLoading,
  setUserId,
}) => {
  try {
    const { data, status } = await axios.post(
      "https://engagements.vehub.live/photobooth_api/api/store",
      body
    );
    if (status === 200 && data.user_id) {
      setUserId(data.user_id);
      navigate("/capture");
    }
    setLoading(false);
  } catch (err) {
    console.log(err);
    setError(err);
    setLoading(false);
  }
};

export const removeBackground = async (body) => {
  try {
    const response = await axios({
      method: "post",
      url: "https://api.remove.bg/v1.0/removebg",
      data: body,
      responseType: "arraybuffer",
      headers: {
        "X-Api-Key": "eG8PqiH8i5dJAo5jgwZbA5SH",
        size: "full",
      },
      encoding: null,
    });

    return response;
  } catch (err) {
    console.log(err);
  }
};

// export const removeBackground = async ({
//   body,
//   setCamImage,
//   setCamLoading,
//   next,
// }) => {
//   try {
//     setCamLoading(true);
//     const response = await axios.post(
//       "https://dreamcast.co.in/s3image/crop.php",
//       body
//     );
//     if (response?.status === 200) {
//       setCamImage(response?.data?.data);
//       setCamLoading(false);
//       next();
//     }
//   } catch (err) {
//     return err;
//   }
// };
